<template>
  <div>
    <slot v-if="flag"/>
    <h6 v-else>
      <span class="badge badge-soft-dark text-white" style="cursor: default">
        ?
      </span>
    </h6>
  </div>
</template>

<script>
export default {
  name: "CheckedData",
  props: {
    flag: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>